import { render, staticRenderFns } from "./TCheckbox.vue?vue&type=template&id=e9f918a2&"
import script from "./TCheckbox.vue?vue&type=script&lang=js&"
export * from "./TCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports